// import React, { useEffect, useRef, useState } from 'react';
// import { Form, Formik } from 'formik';
// import classNames from 'classnames';
// import { useAppDispatch, useAppSelector } from 'src/store/hooks';
// import { Button, Card, Loader, Tabs, TTabItem, Typography } from 'src/components/common';
// import { SearchIcon } from 'src/components/common/common.icons';
// import InputField from 'src/components/common/formFields/inputField/InputField';
// import {
//   TCreateGroupActionRequest,
//   TGetCompany,
//   TListOneToOneChatsRequest,
//   TListOneToOneChatsResponseData
// } from 'src/services/apiEndpoint.types.ts';
// import { useNavigate } from 'react-router-dom';

// import { clearChatLists, clearLocalChat, createGroup, getGroups, listOneToOneChats, markChatAsRead } from 'src/store/chat/chat.slice';
// import useDebounce from 'src/hooks/useDebounce/useDebounce';

// import { TChatListProps } from './chatList.types';
// import './chatList.scss';

// import ChatListUserCard from '../chatListUserCard/ChatListUserCard';
// import Discussion from '../discussion/Discussion';

// import { Container } from 'react-bootstrap';
// import ToggleSwitch from 'src/components/common/ToggleSwitch/ToggleSwitch';
// import { AiFillAlipaySquare } from 'react-icons/ai';
// import { TUserTypes } from 'src/constants/user.constants';
// import { FiEdit } from "react-icons/fi";
// import useToggleCreateEditGroupModal from '../createEditGroup/useToggleCreateEditGroupModal';
// import CreateEditGroup from '../discussion/discussionList/createEditGroup/CreateEditGroup';
// import DiscussionGroupItem from '../discussion/discussionGroupItem/DiscussionListGroupItem';
// import { useUrlParamValue } from 'src/hooks';
// import { TDiscussionTypes } from '../chat.type';
// import { StorageUtils } from 'src/utils';

// const ChatList = ({
//   selectedUserId,
//   selectedUserType,
//   showChatList,
//   authenticatedId,
//   loggedInUserType
//   // localChat
// }: TChatListProps) => {
//   // Hooks
//   const { paramValue } = useUrlParamValue();
//   const dispatch = useAppDispatch();
//   const {
//     oneToOneChatListItemsPerPage,
//     oneToOneChatLists,
//     isDirectChatNotInitiated,
//     listOneToOneChatsLoader,
//     Groups, GroupParticipants,
//     localChat
//   } = useAppSelector((store) => store.chat);
//   const { profile } = useAppSelector((store) => store.profile);
//   const {
//     myCompany,
//     viewCompany,
//     contactUsModalState
//   }: {
//     myCompany: TGetCompany;
//     contactUsModalState?: { state: boolean };
//     viewCompany?: TGetCompany;
//   } = useAppSelector((store) => store.company);
//   const navigate = useNavigate();
//   const { toggleCreateEditGroupModal, isToggleCreateEditGroupModalOpen } =
//     useToggleCreateEditGroupModal({ mode: 'Add' });

//   // ref 
//   const chatItemRef: any = useRef()
//   const hasFetchedChatLists = useRef(false); // Add this ref
//   // State
//   const [activeButton, setActiveButton] = useState<string>('all')
//   const [filterString, setFilterString] = useState<string>('');
//   const [loadIds, setLoadIds] = useState<string[]>([])
//   const [initalValues, setInitialValues] = useState({
//     filterString: ''
//   })
//   const [filteredList, setFilteredList] =
//     useState<TListOneToOneChatsResponseData[] | any>([...oneToOneChatLists, ...Groups]);
//   const [personalChatList, setPersonalChatList] =
//     useState<TListOneToOneChatsResponseData[]>(oneToOneChatLists);
//   const [groupList, setGroupList] = useState(sortHandler(Groups))
//   const [activeChatTab, setActiveChatTab] = useState<string>('personal');

//   // derived state or constant
//   const discussionType: TDiscussionTypes = paramValue({
//     paramName: 'chatType'
//   }) as unknown as TDiscussionTypes;
//   const prev: string = paramValue({
//     paramName: 'prev'
//   }) as unknown as string;
//   const groupId: string = paramValue({ paramName: 'groupId' }) || '';
//   const conversationId: string = paramValue({ paramName: 'conversationId' }) || '';
//   const initiated: string = paramValue({ paramName: 'initiated' }) || '';

//   function sortHandler(arr) {
//     const array = JSON.parse(JSON.stringify(arr));
//     return array.sort((a: any, b: any) => {
//       return new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime();
//     })
//   }

//   function sortByTargetId(arr, targetId: string) {
//     const array = JSON.parse(JSON.stringify(arr)); // Deep clone the array
//     const currentTime = new Date().toISOString(); // Get the latest timestamp

//     const sortedData = array.sort((a, b) => {
//       if (a.id === targetId) {
//         a.updatedAt = currentTime; // Update updatedAt when targetId matches
//         return -1; // Move the targetId to the top
//       }
//       if (b.id === targetId) {
//         b.updatedAt = currentTime; // Update updatedAt when targetId matches
//         return 1;
//       }
//       return 0; // Keep the order for other elements the same
//     });

//     return sortedData;
//   }

//   let tabItems: TTabItem[] = [
//     {
//       key: 'personal',
//       text: 'Personal',
//       disabled: false,
//       component: <></>
//     }
//   ];

//   if (myCompany?.type !== 'Incubator' &&
//     myCompany?.type !== 'Pre-Incubator' &&
//     myCompany?.type !== 'Investor' &&
//     myCompany?.type !== 'Accelerator' &&
//     profile?.role !== 'Investor' &&
//     profile?.role !== 'Incubator' &&
//     profile?.role !== 'Pre-Incubator' && myCompany?.id) {
//     tabItems = [...tabItems,
//     {
//       key: 'company',
//       text: 'Company',
//       disabled: false,
//       component: <></>
//     }]
//   }
//   const [initialId, setInitialId] = useState<string>('');

//   const handleChangeSetting = (e) => {
//     const modifiedOneToOneList = localChat?.id && !!initiated ? [localChat, ...oneToOneChatLists] : oneToOneChatLists;
//     let list: any = [];
//     const target = e?.target?.checked
//     if (target) {
//       list = modifiedOneToOneList.filter(
//         (data) => data.moduleType === 'ServiceProvider' && data.ownerId !== authenticatedId
//       )
//     } else {
//       if (
//         myCompany?.type === 'Incubator' ||
//         myCompany?.type === 'Pre-Incubator' ||
//         myCompany?.type === 'Investor' ||
//         myCompany?.type === 'Accelerator'
//       ) {
//         list = modifiedOneToOneList
//       } else {
//         list = modifiedOneToOneList.filter(
//           (item) => {
//             return (
//               item.moduleType !== 'ServiceProvider' ||
//               (item.moduleType === 'ServiceProvider' && item.ownerId === authenticatedId)
//             )
//           }
//         )
//       }
//     }
//     setPersonalChatList(sortHandler(list)?.map((item: any, i: number) => i === 0 ? { ...item, unreadMessageCount: 0 } : item))
//     let mergedList = []

//     if (target) {
//       mergedList = [...list];
//     } else {
//       mergedList = [...list, ...Groups];
//     }

//     let sortedChats = sortHandler(mergedList);

//     // if (groupId) {
//     //   setGroupList(sortByTargetId(Groups, groupId))
//     //   sortedChats = sortByTargetId(sortedChats, groupId)
//     // }
//     if (prev) {
//       sortedChats = sortByTargetId(sortedChats, conversationId)
//     }
//     if (activeButton === 'group') {
//       sortedChats = sortHandler(Groups)
//     }
//     setFilteredList(sortedChats?.map((item: any, i: number) => i === 0 ? { ...item, unreadMessageCount: 0 } : item));
//     // if (filterString) {
//     //   return
//     // }
//     if (groupId && target && activeChatTab === 'company') {
//       const path = `${window.location.pathname}?id=&tab=discussion&chatType=programGroup&groupId=${groupId}`
//       navigate(path)
//       return
//     }
//     if (prev && (!initiated || (initiated && localChat)) && ((target && activeChatTab === 'company') || (!target && activeChatTab !== 'company'))) {
//       return
//     }

//     if (sortedChats?.length > 0) {
//       const filterUser = target ? sortHandler(list) : sortedChats
//       if (initialId !== filterUser?.[0]?.id) {
//         setInitialId(filterUser?.[0]?.id);

//         // dispatch(markChatAsRead({ chatId: filterUser?.[0]?.id }));
//       }
//       if (filterUser?.[0]?.groupName) {
//         const path = `${window.location.pathname}?id=&tab=discussion&chatType=programGroup&groupId=${filterUser?.[0]?.id}`
//         navigate(path);
//         return
//       } else {
//         const path = `${window.location.pathname}`;
//         navigate(path);
//       }
//       const userDetail = filterUser?.[0]?.Users?.[0];
//       const companyDetail = filterUser?.[0]?.Companies?.[0];
//       const userId: any = userDetail?.id ? userDetail?.id : companyDetail?.id;
//       const userType: TUserTypes = userDetail?.id ? 'User' : 'Company';
//       if (filterUser?.[0]?.id) {
//         const path = `${window.location.pathname}?conversationId=${filterUser?.[0]?.id}&userType=${userType}&userId=${userId}`;
//         navigate(path);
//       }
//     } else {
//       const path = `${window.location.pathname}`;
//       navigate(path);
//     }
//   };

//   const handleChatList = (e) => {
//     const modifiedOneToOneList = localChat?.id && !!initiated ? [localChat, ...oneToOneChatLists] : oneToOneChatLists;
//     let list: any = [];
//     const target = e?.target?.checked
//     if (target) {
//       list = modifiedOneToOneList.filter(
//         (data) => data.moduleType === 'ServiceProvider' && data.ownerId !== authenticatedId
//       )
//     } else {
//       if (
//         myCompany?.type === 'Incubator' ||
//         myCompany?.type === 'Pre-Incubator' ||
//         myCompany?.type === 'Investor' ||
//         myCompany?.type === 'Accelerator'
//       ) {
//         list = modifiedOneToOneList
//       } else {
//         list = modifiedOneToOneList.filter(
//           (item) => {
//             return (
//               item.moduleType !== 'ServiceProvider' ||
//               (item.moduleType === 'ServiceProvider' && item.ownerId === authenticatedId)
//             )
//           }
//         )
//       }
//     }
//     setPersonalChatList(sortHandler(list)?.map((item: any, i: number) => i === 0 ? { ...item } : item))
//     let mergedList = []

//     if (target) {
//       mergedList = [...list];
//     } else {
//       mergedList = [...list, ...Groups];
//     }

//     let sortedChats = sortHandler(mergedList);

//     // if (groupId) {
//     //   setGroupList(sortByTargetId(Groups, groupId))
//     //   sortedChats = sortByTargetId(sortedChats, groupId)
//     // }
//     if (prev) {
//       sortedChats = sortByTargetId(sortedChats, conversationId)
//     }
//     setFilteredList(sortedChats?.map((item: any, i: number) => i === 0 ? { ...item } : item));
//   }

//   const getChatLists = () => {
//     const payload: TListOneToOneChatsRequest = {
//       userId: authenticatedId,
//       userType: loggedInUserType,
//       limit: 10000000,
//       offset: 1,
//       ...(filterString && { filterString })
//     };

//     dispatch(listOneToOneChats(payload));
//   };
//   const handleGetGroups = () => {
//     const payload: any = {
//       userId: authenticatedId,
//       userType: loggedInUserType,
//       ...(filterString && { filterString })
//     };

//     dispatch(getGroups(payload));
//   };

//   const changeChatTab = (value: string, resetForm?: () => void) => {
//     setFilterString('')
//     setInitialValues({ filterString: '' })
//     resetForm()
//     handleChangeSetting({ target: { checked: value === 'company' } })
//     setActiveButton('all');
//     setActiveChatTab(value)
//   };

//   const handleCreateGroup = (formValues: { groupName: string; usersToAdd: any[] }) => {
//     const usersToAdd: string[] = formValues?.usersToAdd;

//     const usersToAddObj: {
//       userId: string;
//       userType: TUserTypes;
//     }[] = usersToAdd.map((userId: any) => ({
//       userId: userId.id,
//       userType: userId.role !== null ? 'User' : 'Company'
//     }));
//     // Adding the owner as the first item in the array.
//     usersToAddObj.unshift({ userId: authenticatedId, userType: loggedInUserType });
//     const payload: TCreateGroupActionRequest = {
//       moduleType: 'General',
//       groupName: formValues?.groupName,
//       usersToAdd: usersToAddObj,
//       userId: authenticatedId,
//       userType: loggedInUserType
//     };
//     dispatch(createGroup(payload));
//   };

//   useDebounce({
//     func: () => {
//       getChatLists();
//       handleGetGroups()
//     },
//     delay: 500,
//     dependency: filterString
//   });
//   function handleChat() {
//     if (!hasFetchedChatLists.current) { // Check if the function has already been called
//       getChatLists();
//       handleGetGroups();
//       hasFetchedChatLists.current = true; // Set the ref to true after calling the function
//     }
//   }

//   useEffect(() => {
//     handleChat()
//     if (localChat?.id) {
//       setFilteredList([localChat])
//     }
//     return () => {
//       dispatch(clearChatLists());
//     };
//   }, []);
//   useEffect(() => {
//     if ((groupId || conversationId)) {
//       handleChangeSetting({ target: { checked: activeChatTab === 'company' } });
//     } else {
//       handleChatList({ target: { checked: activeChatTab === 'company' } });
//     }
//   }, [oneToOneChatLists, Groups, localChat, activeButton]);
//   useEffect(() => {
//     setGroupList(sortHandler(Groups))
//   }, [Groups]);

//   useEffect(() => {
//     if (chatItemRef.current?.firstChild) {
//       chatItemRef.current.firstChild.scrollIntoView({ behavior: 'smooth', block: 'start' });
//     }
//   }, [filteredList, activeChatTab, personalChatList]);
//   return (
//     <>
//       <Card className={classNames('chat-list', { 'chat-list--show-on-mobile': showChatList })}>
//         <div className="chat-list__heading">
//           <div className="chat-list__heading__chatLabel">
//             <Typography variant="subHeading-2" fontWeight="semiBold" className='chatNameHead'>
//               Chats
//             </Typography>
//             <div className="chat-list__heading__editIcon">
//               <FiEdit onClick={toggleCreateEditGroupModal} />
//             </div>
//           </div>
//           <Formik initialValues={initalValues} onSubmit={() => { }} enableReinitialize>
//             {({ setFieldValue, values, resetForm }) => {
//               return (
//                 <>
//                   <Tabs
//                     onTabChange={(value) => {
//                       changeChatTab(value, resetForm); // Pass resetForm to ensure input resets
//                     }}
//                     activeItem={activeChatTab}
//                     items={tabItems}
//                   />
//                   <Form>
//                     <InputField
//                       id="filterString"
//                       startIcon={<SearchIcon />}
//                       placeholder="Search Chats"
//                       value={values.filterString}
//                       onChange={(e) => {
//                         const value = e.target.value;
//                         setFieldValue('filterString', value);
//                         setFilterString(value);
//                       }}
//                     />
//                   </Form>
//                 </>
//               );
//             }}
//           </Formik>
//         </div>
//         {/* <div>
//           <Discussion />
//         </div> */}

//         {true && (
//           <>
//             {activeChatTab !== 'company' && <div className="chat-list__allBtnGroup">
//               <Button
//                 variant={activeButton === 'all' ? "primary" : "secondary"}
//                 size="small"
//                 onClick={() => setActiveButton('all')}
//               >
//                 All
//               </Button>
//               <Button
//                 variant={activeButton === 'group' ? "primary" : "secondary"}
//                 size="small"
//                 onClick={() => setActiveButton('group')}
//               >
//                 Groups
//               </Button>
//               {/* <Button
//                 variant={activeButton === 'undreads' ? "primary" : "secondary"}
//                 size="small"
//                 onClick={() => setActiveButton('undreads')}
//               >
//                 Unreads
//               </Button> */}
//             </div>}
//             {([...(activeChatTab === 'company' ? personalChatList : filteredList)]?.length > 0) && <div className="chat-list__users" ref={chatItemRef}>
//               {activeButton === 'all' && [...(activeChatTab === 'company' ? personalChatList : filteredList)]?.map((user: any, index: number) => {
//                 if (user.groupName) {
//                   return (
//                     <DiscussionGroupItem
//                       key={index}
//                       group={user}
//                       groupId={groupId}
//                       discussionType={discussionType}
//                       programId={''}
//                     />
//                   )
//                 }
//                 return (
//                   <ChatListUserCard
//                     key={index}
//                     {...user}
//                     selectedUserId={selectedUserId}
//                     selectedUserType={selectedUserType}
//                     authenticatedId={authenticatedId}
//                     loggedInUserType={loggedInUserType}
//                   />
//                 );
//                 // }
//               })}
//               {activeButton === 'group' && activeChatTab !== 'company' && groupList?.map((group, index) => (
//                 <DiscussionGroupItem
//                   key={index}
//                   group={group}
//                   groupId={groupId}
//                   discussionType={discussionType}
//                   programId={''}
//                 />
//               ))}
//             </div>}
//           </>
//         )}
//         {isDirectChatNotInitiated && filteredList?.length === 0 && (
//           <div className="chat-list__not-initiated">
//             <Typography variant="subHeading-2" fontWeight="semiBold">
//               No Users Yet!
//             </Typography>
//             <Typography variant="caption" fontWeight="regular">
//               It looks like no one has been added yet. Reach out and start a conversation here.
//             </Typography>
//           </div>
//         )}
//         {listOneToOneChatsLoader && <Loader />}
//       </Card>
//       {isToggleCreateEditGroupModalOpen && (
//         <CreateEditGroup
//           mode="Add"
//           isModalOpen={isToggleCreateEditGroupModalOpen}
//           onModalClose={toggleCreateEditGroupModal}
//           onSubmit={handleCreateGroup}
//         />
//       )}
//     </>
//   );
// };

// export default ChatList;

import React, { useEffect, useRef, useState } from 'react';
import { Form, Formik } from 'formik';
import classNames from 'classnames';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { Button, Card, Loader, Tabs, TTabItem, Typography } from 'src/components/common';
import { SearchIcon } from 'src/components/common/common.icons';
import InputField from 'src/components/common/formFields/inputField/InputField';
import {
  TCreateGroupActionRequest,
  TGetCompany,
  TListOneToOneChatsRequest,
  TListOneToOneChatsResponseData
} from 'src/services/apiEndpoint.types.ts';
import { useLocation, useNavigate } from 'react-router-dom';

import { clearChatLists, clearLocalChat, createGroup, getGroups, listOneToOneChats, markChatAsRead } from 'src/store/chat/chat.slice';
import useDebounce from 'src/hooks/useDebounce/useDebounce';

import { TChatListProps } from './chatList.types';
import './chatList.scss';

import ChatListUserCard from '../chatListUserCard/ChatListUserCard';
import Discussion from '../discussion/Discussion';

import { Container } from 'react-bootstrap';
import ToggleSwitch from 'src/components/common/ToggleSwitch/ToggleSwitch';
import { AiFillAlipaySquare } from 'react-icons/ai';
import { TUserTypes } from 'src/constants/user.constants';
import { FiEdit } from "react-icons/fi";
import useToggleCreateEditGroupModal from '../createEditGroup/useToggleCreateEditGroupModal';
import CreateEditGroup from '../discussion/discussionList/createEditGroup/CreateEditGroup';
import DiscussionGroupItem from '../discussion/discussionGroupItem/DiscussionListGroupItem';
import { useUrlParamValue } from 'src/hooks';
import { TDiscussionTypes } from '../chat.type';
import { StorageUtils } from 'src/utils';

const ChatList = ({
  selectedUserId,
  selectedUserType,
  showChatList,
  authenticatedId,
  loggedInUserType
}: TChatListProps) => {
  // Hooks
  const location = useLocation();
  const searchQuery = location.search;
  const { paramValue } = useUrlParamValue();
  const dispatch = useAppDispatch();
  const {
    oneToOneChatListItemsPerPage,
    oneToOneChatLists,
    isDirectChatNotInitiated,
    listOneToOneChatsLoader,
    Groups, GroupParticipants,
    localChat
  } = useAppSelector((store) => store.chat);
  const { profile } = useAppSelector((store) => store.profile);
  const {
    myCompany,
    viewCompany,
    contactUsModalState
  }: {
    myCompany: TGetCompany;
    contactUsModalState?: { state: boolean };
    viewCompany?: TGetCompany;
  } = useAppSelector((store) => store.company);
  const navigate = useNavigate();
  const { toggleCreateEditGroupModal, isToggleCreateEditGroupModalOpen } =
    useToggleCreateEditGroupModal({ mode: 'Add' });

  // ref 
  const chatItemRef: any = useRef()
  const hasFetchedChatLists = useRef(false);
  // State
  const [activeButton, setActiveButton] = useState<string>('all')
  const [filterString, setFilterString] = useState<string>('');
  const [initalValues, setInitialValues] = useState({
    filterString: ''
  })
  const [filteredList, setFilteredList] =
    useState<TListOneToOneChatsResponseData[] | any>([...oneToOneChatLists, ...Groups]);
  const [personalChatList, setPersonalChatList] =
    useState<TListOneToOneChatsResponseData[]>(oneToOneChatLists);
  const [groupList, setGroupList] = useState(sortHandler(Groups))
  const [activeChatTab, setActiveChatTab] = useState<string>('personal');
  // Adding a flag to track data refresh
  const [shouldRefreshData, setShouldRefreshData] = useState<boolean>(false);
  const prevRouteRef: any = useRef(null)
  // derived state or constant
  const discussionType: TDiscussionTypes = paramValue({
    paramName: 'chatType'
  }) as unknown as TDiscussionTypes;
  const prev: string = paramValue({
    paramName: 'prev'
  }) as unknown as string;
  const groupId: string = paramValue({ paramName: 'groupId' }) || '';
  const conversationId: string = paramValue({ paramName: 'conversationId' }) || '';
  const initiated: string = paramValue({ paramName: 'initiated' }) || '';

  function sortHandler(arr) {
    const array = JSON.parse(JSON.stringify(arr));
    return array.sort((a: any, b: any) => {
      return new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime();
    })
  }

  function sortByTargetId(arr, targetId: string) {
    const array = JSON.parse(JSON.stringify(arr));
    const currentTime = new Date().toISOString();

    const sortedData = array.sort((a, b) => {
      if (a.id === targetId) {
        a.updatedAt = currentTime;
        return -1;
      }
      if (b.id === targetId) {
        b.updatedAt = currentTime;
        return 1;
      }
      return 0;
    });

    return sortedData;
  }

  let tabItems: TTabItem[] = [
    {
      key: 'personal',
      text: 'Personal',
      disabled: false,
      component: <></>
    }
  ];

  if (myCompany?.type !== 'Incubator' &&
    myCompany?.type !== 'Pre-Incubator' &&
    myCompany?.type !== 'Investor' &&
    myCompany?.type !== 'Accelerator' &&
    profile?.role !== 'Investor' &&
    profile?.role !== 'Incubator' &&
    profile?.role !== 'Pre-Incubator' && myCompany?.id) {
    tabItems = [...tabItems,
    {
      key: 'company',
      text: 'Company',
      disabled: false,
      component: <></>
    }]
  }
  const [initialId, setInitialId] = useState<string>('');

  // Function to fetch data from database
  const fetchDataFromDB = () => {
    // Clear existing data first
    dispatch(clearChatLists());

    // Fetch fresh data
    getChatLists();
    handleGetGroups();

    // Reset the refresh flag
    setShouldRefreshData(false);
  };

  const handleChangeSetting = (e) => {
    const modifiedOneToOneList = localChat?.id && !!initiated ? [localChat, ...oneToOneChatLists] : oneToOneChatLists;
    let list: any = [];
    const target = e?.target?.checked
    if (target) {
      list = modifiedOneToOneList.filter(
        (data) => data.moduleType === 'ServiceProvider' && data.ownerId !== authenticatedId
      )
    } else {
      if (
        myCompany?.type === 'Incubator' ||
        myCompany?.type === 'Pre-Incubator' ||
        myCompany?.type === 'Investor' ||
        myCompany?.type === 'Accelerator'
      ) {
        list = modifiedOneToOneList
      } else {
        list = modifiedOneToOneList.filter(
          (item) => {
            return (
              item.moduleType !== 'ServiceProvider' ||
              (item.moduleType === 'ServiceProvider' && item.ownerId === authenticatedId)
            )
          }
        )
      }
    }
    setPersonalChatList(sortHandler(list)?.map((item: any, i: number) => i === 0 ? { ...item, unreadMessageCount: 0 } : item))
    let mergedList = []

    if (target) {
      mergedList = [...list];
    } else {
      mergedList = [...list, ...Groups];
    }

    let sortedChats = sortHandler(mergedList);

    if (prev) {
      sortedChats = sortByTargetId(sortedChats, conversationId)
    }
    if (activeButton === 'group') {
      sortedChats = sortHandler(Groups)
    }
    setFilteredList(sortedChats?.map((item: any, i: number) => i === 0 ? { ...item, unreadMessageCount: 0 } : item));

    if (groupId && target && activeChatTab === 'company') {
      const path = `${window.location.pathname}?id=&tab=discussion&chatType=programGroup&groupId=${groupId}`
      navigate(path)
      return
    }
    if (prev && (!initiated || (initiated && localChat)) && ((target && activeChatTab === 'company') || (!target && activeChatTab !== 'company'))) {
      return
    }

    if (sortedChats?.length > 0) {
      const filterUser = target ? sortHandler(list) : sortedChats
      if (initialId !== filterUser?.[0]?.id) {
        setInitialId(filterUser?.[0]?.id);
      }
      if (filterUser?.[0]?.groupName) {
        const path = `${window.location.pathname}?id=&tab=discussion&chatType=programGroup&groupId=${filterUser?.[0]?.id}`
        navigate(path);
        return
      } else {
        const path = `${window.location.pathname}`;
        navigate(path);
      }
      const userDetail = filterUser?.[0]?.Users?.[0];
      const companyDetail = filterUser?.[0]?.Companies?.[0];
      const userId: any = userDetail?.id ? userDetail?.id : companyDetail?.id;
      const userType: TUserTypes = userDetail?.id ? 'User' : 'Company';
      if (filterUser?.[0]?.id) {
        const path = `${window.location.pathname}?conversationId=${filterUser?.[0]?.id}&userType=${userType}&userId=${userId}`;
        navigate(path);
      }
    } else {
      const path = `${window.location.pathname}`;
      navigate(path);
    }
  };

  const handleChatList = (e) => {
    const modifiedOneToOneList = localChat?.id && !!initiated ? [localChat, ...oneToOneChatLists] : oneToOneChatLists;
    let list: any = [];
    const target = e?.target?.checked
    if (target) {
      list = modifiedOneToOneList.filter(
        (data) => data.moduleType === 'ServiceProvider' && data.ownerId !== authenticatedId
      )
    } else {
      if (
        myCompany?.type === 'Incubator' ||
        myCompany?.type === 'Pre-Incubator' ||
        myCompany?.type === 'Investor' ||
        myCompany?.type === 'Accelerator'
      ) {
        list = modifiedOneToOneList
      } else {
        list = modifiedOneToOneList.filter(
          (item) => {
            return (
              item.moduleType !== 'ServiceProvider' ||
              (item.moduleType === 'ServiceProvider' && item.ownerId === authenticatedId)
            )
          }
        )
      }
    }
    setPersonalChatList(sortHandler(list)?.map((item: any, i: number) => i === 0 ? { ...item } : item))
    let mergedList = []

    if (target) {
      mergedList = [...list];
    } else {
      mergedList = [...list, ...Groups];
    }

    let sortedChats = sortHandler(mergedList);

    if (prev) {
      sortedChats = sortByTargetId(sortedChats, conversationId)
    }
    setFilteredList(sortedChats?.map((item: any, i: number) => i === 0 ? { ...item } : item));
  }

  const getChatLists = () => {
    const payload: TListOneToOneChatsRequest = {
      userId: authenticatedId,
      userType: loggedInUserType,
      limit: 10000000,
      offset: 1,
      ...(filterString && { filterString })
    };

    dispatch(listOneToOneChats(payload));
  };

  const handleGetGroups = () => {
    const payload: any = {
      userId: authenticatedId,
      userType: loggedInUserType,
      ...(filterString && { filterString })
    };

    dispatch(getGroups(payload));
  };

  const changeChatTab = (value: string, resetForm?: () => void) => {
    setFilterString('')
    setInitialValues({ filterString: '' })
    resetForm && resetForm()

    // Trigger a data refresh when switching tabs
    setShouldRefreshData(true);
    setActiveButton('all');
    setActiveChatTab(value);
    // const prevData = prevRouteRef?.current || ''
    // if (prevRouteRef && searchQuery) {
    //   prevRouteRef.current = searchQuery
    // }
    // if (prevData) {
    //   navigate(`/chat${prevData}`)
    // }
    // handleChangeSetting({ target: { checked: value === 'company' } })
    navigate('/chat')
    handleChatList({ target: { checked: value === 'company' } })
  };

  // Handle button group changes
  const handleButtonChange = (buttonType: string) => {
    // Refresh data when switching between button types
    setShouldRefreshData(true);
    navigate('/chat')
    handleChatList({ target: { checked: false } })
    setActiveButton(buttonType);
  };

  const handleCreateGroup = (formValues: { groupName: string; usersToAdd: any[] }) => {
    const usersToAdd: string[] = formValues?.usersToAdd;

    const usersToAddObj: {
      userId: string;
      userType: TUserTypes;
    }[] = usersToAdd.map((userId: any) => ({
      userId: userId.id,
      userType: userId.role !== null ? 'User' : 'Company'
    }));
    // Adding the owner as the first item in the array.
    usersToAddObj.unshift({ userId: authenticatedId, userType: loggedInUserType });
    const payload: TCreateGroupActionRequest = {
      moduleType: 'General',
      groupName: formValues?.groupName,
      usersToAdd: usersToAddObj,
      userId: authenticatedId,
      userType: loggedInUserType
    };
    dispatch(createGroup(payload));
  };

  useDebounce({
    func: () => {
      getChatLists();
      handleGetGroups()
    },
    delay: 500,
    dependency: filterString
  });

  function handleChat() {
    if (!hasFetchedChatLists.current) {
      getChatLists();
      handleGetGroups();
      hasFetchedChatLists.current = true;
    }
  }

  useEffect(() => {
    handleChat()
    if (localChat?.id) {
      setFilteredList([localChat])
    }
    return () => {
      dispatch(clearChatLists());
    };
  }, []);

  useEffect(() => {
    if ((groupId || conversationId)) {
      handleChangeSetting({ target: { checked: activeChatTab === 'company' } });
    } else {
      handleChatList({ target: { checked: activeChatTab === 'company' } });
    }
  }, [oneToOneChatLists, Groups, localChat, activeButton]);

  useEffect(() => {
    setGroupList(sortHandler(Groups))
  }, [Groups]);

  useEffect(() => {
    if (chatItemRef.current?.firstChild) {
      chatItemRef.current.firstChild.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [filteredList, activeChatTab, personalChatList]);

  // Add an effect to handle data refreshing
  useEffect(() => {
    if (shouldRefreshData) {
      fetchDataFromDB();
    }
  }, [shouldRefreshData]);

  return (
    <>
      <Card className={classNames('chat-list', { 'chat-list--show-on-mobile': showChatList })}>
        <div className="chat-list__heading">
          <div className="chat-list__heading__chatLabel">
            <Typography variant="subHeading-2" fontWeight="semiBold" className='chatNameHead'>
              Chats
            </Typography>
            <div className="chat-list__heading__editIcon">
              <FiEdit onClick={toggleCreateEditGroupModal} />
            </div>
          </div>
          <Formik initialValues={initalValues} onSubmit={() => { }} enableReinitialize>
            {({ setFieldValue, values, resetForm }) => {
              return (
                <>
                  <Tabs
                    onTabChange={(value) => {
                      changeChatTab(value, resetForm);
                    }}
                    activeItem={activeChatTab}
                    items={tabItems}
                  />
                  <Form>
                    <InputField
                      id="filterString"
                      startIcon={<SearchIcon />}
                      placeholder="Search Chats"
                      value={values.filterString}
                      onChange={(e) => {
                        const value = e.target.value;
                        setFieldValue('filterString', value);
                        setFilterString(value);
                      }}
                    />
                  </Form>
                </>
              );
            }}
          </Formik>
        </div>

        {true && (
          <>
            {activeChatTab !== 'company' && <div className="chat-list__allBtnGroup">
              <Button
                variant={activeButton === 'all' ? "primary" : "secondary"}
                size="small"
                onClick={() => handleButtonChange('all')}
              >
                All
              </Button>
              <Button
                variant={activeButton === 'group' ? "primary" : "secondary"}
                size="small"
                onClick={() => handleButtonChange('group')}
              >
                Groups
              </Button>
              {/* <Button
                variant={activeButton === 'undreads' ? "primary" : "secondary"}
                size="small"
                onClick={() => handleButtonChange('undreads')}
              >
                Unreads
              </Button> */}
            </div>}
            {([...(activeChatTab === 'company' ? personalChatList : filteredList)]?.length > 0) && <div className="chat-list__users" ref={chatItemRef}>
              {activeButton === 'all' && [...(activeChatTab === 'company' ? personalChatList : filteredList)]?.map((user: any, index: number) => {
                if (user.groupName) {
                  return (
                    <DiscussionGroupItem
                      key={index}
                      group={user}
                      groupId={groupId}
                      discussionType={discussionType}
                      programId={''}
                    />
                  )
                }
                return (
                  <ChatListUserCard
                    key={index}
                    {...user}
                    selectedUserId={selectedUserId}
                    selectedUserType={selectedUserType}
                    authenticatedId={authenticatedId}
                    loggedInUserType={loggedInUserType}
                  />
                );
              })}
              {activeButton === 'group' && activeChatTab !== 'company' && groupList?.map((group, index) => (
                <DiscussionGroupItem
                  key={index}
                  group={group}
                  groupId={groupId}
                  discussionType={discussionType}
                  programId={''}
                />
              ))}
            </div>}
          </>
        )}
        {isDirectChatNotInitiated && filteredList?.length === 0 && (
          <div className="chat-list__not-initiated">
            <Typography variant="subHeading-2" fontWeight="semiBold">
              No Users Yet!
            </Typography>
            <Typography variant="caption" fontWeight="regular">
              It looks like no one has been added yet. Reach out and start a conversation here.
            </Typography>
          </div>
        )}
        {listOneToOneChatsLoader && <Loader />}
      </Card>
      {isToggleCreateEditGroupModalOpen && (
        <CreateEditGroup
          mode="Add"
          isModalOpen={isToggleCreateEditGroupModalOpen}
          onModalClose={toggleCreateEditGroupModal}
          onSubmit={handleCreateGroup}
        />
      )}
    </>
  );
};

export default ChatList;
